import "@hotwired/turbo-rails";
import "./controllers";

document.addEventListener("click", (e) => {
  const event = e.target.closest("[data-event]");

  if (event && window.gtag) {
    window.gtag("event", event.dataset.event, {
      event_category: event.dataset.category,
      event_label: event.dataset.label,
    });
  }
});

document.addEventListener("change", (event) => {
  const target = event.target;

  if (target.id === "language") {
    const slug = target.value;

    window.Turbo.visit(`/books/${slug}`);
  }
});
